import * as CURRENCY_SYMBOL_SIDE from './currencySymbolSideConstant';

/**
 * @description dynamically format the currency amount
 * @param {Number} amount - amount received from the user, (which might from an api response)
 * @param {String} currencySymbolSide - `leftSpaceCode`,`leftCode`,`rightSpaceCode`,`rightCode`
 * @param {String} currencySymbol `$` etc.
 * @param {String} currencyCode `CAD`,`INR`,`USD` etc.
 * @param {Number} decimal `0`,`1`,`2` etc.
 * @example formatCurrency(123.22,'leftSpaceCode','$','USD',1)
 */
export const formatCurrency = (amount, currencySymbolSide, currencySymbol, currencyCode, decimal) => {
  if (amount !== 'undefined' || amount !== undefined) {
    let result = Number(amount).toLocaleString(undefined, {
      minimumFractionDigits: decimal ?? 2,
    });

    currencySymbol = import.meta.env.VITE_ALLOWED_CRYPTO_CURRENCY.split(',').includes(currencySymbol?.toUpperCase()) ? '' : currencySymbol;

    // Guard against undefined/null symbol or code leaking into the output as the
    // literal string "undefined" (e.g. campaign has no equity currency set).
    currencySymbol = currencySymbol ?? '';
    currencyCode = currencyCode ?? '';

    result = result === 'NaN' ? '-' : result;
    switch (currencySymbolSide) {
      case CURRENCY_SYMBOL_SIDE.LEFT_SPACE_CODE:
        return currencySymbol + ' ' + result + ' ' + currencyCode;
      case CURRENCY_SYMBOL_SIDE.RIGHT_SPACE_CODE:
        return result + ' ' + currencySymbol + ' ' + currencyCode;
      case CURRENCY_SYMBOL_SIDE.LEFT_CODE:
        return currencySymbol + '' + result + ' ' + currencyCode;
      case CURRENCY_SYMBOL_SIDE.RIGHT_CODE:
        return result + '' + currencySymbol + ' ' + currencyCode;
      default:
        break;
    }
  }
};


export const toUsd = function (val1, val2) {
  const result = Math.round((Number(val1) * Number(val2) + Number.EPSILON) * 100) / 100;
  return isNaN(result) || result === 0 ? '0.00' : result;
};